import React from "react";
import { bool, element, string, array, oneOfType } from "prop-types";

const EventCard = ({
    title,
    image,
    webp,
    link,
    linkLabel,
    linkTarget,
    startDate,
    endDate,
    comingSoon,
    venue,
    address
}) => (
    <div className="ae__event__card">
        <a href={link} target={linkTarget} className="ae__event__a">
            <picture>
                {webp && <source srcSet={webp} type="image/webp" /> }
                <img src={image} alt={title} className="ae__event__img" loading="lazy" width="710" height="210" />
            </picture>
        </a>
        <div className="ae__event__header">
            {comingSoon
                ? <h3 className="ae__event__subtitle">Dates Coming Soon</h3>
                : endDate
                    ? <h3 className="ae__event__subtitle">{startDate} - {endDate}</h3>
                    : <h3 className="ae__event__subtitle">{startDate}</h3>
            }
        </div>
        <div className="ae__event__body">
            <h3 className="ae__event__title">{title}</h3>
            <div className="ae__event__info">
                {venue && address && (
                    <div className="ae__event__location">
                        {venue && (
                            <p className="ae__event__venue"><i className="far fa-building fa-lg"></i>{venue}</p>
                        )}
                        {address && (
                            <p className="ae__event__address"><i className="far fa-map-marker-alt fa-lg"></i>{address}</p>
                        )}
                    </div>
                )}
                <a className="ae__event__button" href={link} target={linkTarget} >{linkLabel}</a>
            </div>
        </div>
    </div>
);

EventCard.defaultProps = {
    linkLabel: "View Details",
    linkTarget: "_self"
};

EventCard.propTypes = {
    title: string,
    image: string,
    webp: string,
    link: string,
    linkTarget: string,
    linkLabel: string,
    startDate: oneOfType([
        bool,
        element,
        string,
        array
    ]),
    endDate: oneOfType([
        bool,
        element,
        string,
        array
    ]),
    comingSoon: bool,
    venue: string,
    address: string
};

export default EventCard;